import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { space } from "../tokens/scale.js";
import { cx } from "./cx.js";
export function Stack({ direction = "column", gap = 4, align, justify, wrap = false, grow = false, as: Tag = "div", className, style, children, }) {
    return (_jsx(Tag, { className: className, style: {
            display: "flex",
            flexDirection: direction,
            gap: gap === 0 ? 0 : space(gap),
            alignItems: align,
            justifyContent: justify,
            flexWrap: wrap ? "wrap" : "nowrap",
            flexGrow: grow ? 1 : undefined,
            minWidth: 0,
            ...style,
        }, children: children }));
}
export function Surface({ tone = "surface", padding = "block", now = false, dashed = false, flat = false, split = false, bounded, as: Tag = "div", className, style, children, }) {
    return (_jsx(Tag, { className: cx("block", tone === "bg" && "block-bg", tone === "sunk" && "block-sunk", now && "block-now", dashed && "block-dashed", flat && "block-flat", split && "split", padding === "block" && "pad", padding === "x" && "pad-x", className), style: {
            ...(typeof padding === "number" ? { padding: space(padding) } : {}),
            ...(bounded !== undefined
                ? { height: `${bounded}px`, display: "flex", flexDirection: "column" }
                : {}),
            ...style,
        }, "data-bounded": bounded !== undefined || undefined, children: children }));
}
export function Section({ title, aside, id, className, children }) {
    return (_jsxs("section", { className: cx("sec", className), "aria-labelledby": id, children: [_jsxs("h2", { className: "sec-head", children: [_jsx("span", { id: id, className: "label", children: title }), aside] }), children] }));
}
//# sourceMappingURL=Layout.js.map